
































































































































import ShiftFilters from "../Filters/ShiftFilters.vue";
import { shifts } from "../../api/shifts/shifts";
import { personnel } from "../../api/personnel/personnel";
import { Component, Vue, Prop } from "vue-property-decorator";
import Moment from "moment";
@Component({
  name: "ShiftList",
  components: {
    ShiftFilters
  }
})
export default class ShiftList extends Vue {
  public loading: boolean = false;
  public filters: any = {};
  public shiftList: any[] = [];
  public typeList: any[] = [];
  public personnelList: any[] = [];
  public foremen: any[] = [];
  public tableData: any[] = [];
  public index: number = 0;
  public listEnd: boolean = false;
  public handleClick(rowIndex: number, row: any) {
    console.log("ROW");
    console.log(row);
    row.personnel = JSON.stringify(row.personnel);
    this.$store.dispatch("updateCurrentObject", row);
    this.$store.dispatch("updateCurrentComponent", "AddShift");
    this.$router.replace({ name: "load" });
  }

  public getDateTime(date: any) {
    if (date != undefined && date != "") {
      return Moment(date).format("HH:mm");
    }
    return "";
  }
  public more() {
    let i = 0;
    while (i < 10) {
      this.tableData.push(this.shiftList[this.index + 1]);
      i++;
      this.index++;
      if (this.shiftList[this.index + 1] == undefined) {
        this.index--;
        this.listEnd = true;
        return;
      }
    }
  }
  public async deleteShift(rowIndex: number, row: any) {
    await shifts
      .recycleShift(
        this.$store.getters.getToken,
        row.id,
        this.$store.getters.getHost
      )
      .then(async r => this.search());
  }

  public parseForemen() {
    console.log(this.shiftList);
    for (const s of this.shiftList) {
      console.log(s);
      console.log(this.foremen);
      if (
        !this.foremen.some(
          e => e.text === s.foreman.lastname + " " + s.foreman.firstname
        )
      ) {
        this.foremen.push({
          text: s.foreman.lastname + " " + s.foreman.firstname,
          value: s.foreman.lastname + " " + s.foreman.firstname
        });
      }
    }
  }

  public filterHandler(value: any, row: any, column: any) {
    const property = column["property"];
    return row[property] === value;
  }

  public foremanFilter(value: any, row: any, column: any) {
    const property = column["property"];
    return row[property].lastname + " " + row[property].firstname === value;
  }

  public getType(row: any, column: any): String {
    let type = this.typeList.find((obj: any) => obj.id === row.type);
    if (type != undefined) {
      return type.literal;
    }
    return "";
  }

  public getForeman(row: any, column: any): String {
    return row.foreman.lastname + " " + row.foreman.firstname;
  }

  public getTypeFilters() {
    let a = [];
    {
      for (const s of this.typeList) {
        a.push({ value: s.id, text: s.literal });
      }
    }
    return a;
  }

  public filterDateTime(row: any) {
    if (row.shift_date === undefined) {
      return "";
    }
    return Moment(row.shift_date).format("DD/MM/YYYY");
  }

  public async getShiftTypeList() {
    await shifts
      .getShiftTypes(this.$store.getters.getToken, this.$store.getters.getHost)
      .then(response => {
        response.json().then((resp: any) => {
          this.typeList = JSON.parse(JSON.stringify(resp));
        });
      });
  }

  public async getPersonnelList() {
    await personnel
      .getAllPersonnel(
        this.$store.getters.getToken,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then(async resp => {
          this.personnelList = JSON.parse(JSON.stringify(resp));
        });
      });
  }

  public async search() {
    this.listEnd = false;
    this.loading = true;
    this.listEnd = false;
    if (this.filters.dateFrom === null) {
      delete this.filters.dateFrom;
    }
    if (this.filters.dateTo === null) {
      delete this.filters.dateTo;
    }
    await shifts
      .getSomeShifts(
        this.$store.getters.getToken,
        this.filters,
        this.$store.getters.getHost
      )
      .then(response => {
        response.json().then(resp => {
          this.shiftList = JSON.parse(JSON.stringify(resp));
          this.shiftList.sort(function(a, b) {
            var aType = a.type;
            var bType = b.type;
            var aDate = new Date(
              Moment(a.shift_date)
                .hour(0)
                .minutes(0)
                .toDate()
            ).getTime();
            var bDate = new Date(
              Moment(b.shift_date)
                .hour(0)
                .minutes(0)
                .toDate()
            ).getTime();

            if (aDate == bDate) {
              return aType > bType ? -1 : aType < bType ? 1 : 0;
            } else {
              return aDate > bDate ? -1 : 1;
            }
          });
          this.tableData = this.shiftList.slice(0, 10);
          this.index = 10;
          this.parseForemen();
          this.loading = false;
        });
      });
  }

  public async created() {
    this.loading = true;
    await this.getPersonnelList();
    await this.getShiftTypeList();
    this.loading = false;
  }
}
